import { groupBy } from "lodash";
import api from "../config/api";

export const getPos = async (data) => {
  const res = await api.get("po", data);
  return res.data;
};

export const getPoByid = async (_id) => {
  const res = await api.get(`po/${_id}`);
  return res.data;
};

export const getPosGroupedByJob = async () => {
  const res = await api.get("po");
  return groupBy(res.data, (i) => i.job);
};
